// src/useScrollFade.js
import { useEffect, useState } from "react";

export default function useScrollFade() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const top = window.scrollY + window.innerHeight;
      const element = document.querySelector(".fade-in-element");
      if (element && top > element.offsetTop + 100) {
        setIsVisible(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return isVisible;
}